import naja from 'naja';

export default class CartNote {
    private container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.init();
        this.initSnippetListener();
    }

    static init() {
        const container = document.querySelector('.base-cart') as HTMLElement;
        if (container) {
            new CartNote(container);
        }
    }

    private init() {
        this.container.querySelectorAll<HTMLElement>('[data-note-container]').forEach((noteContainer) => {
            const editTrigger = noteContainer.querySelector<HTMLAnchorElement>('[data-note-edit-trigger]');
            const displayEl = noteContainer.querySelector<HTMLElement>('[data-note-display]');
            const formEl = noteContainer.querySelector<HTMLElement>('[data-note-edit-form]');
            const inputEl = noteContainer.querySelector<HTMLTextAreaElement>('[data-note-input]');
            const saveBtn = noteContainer.querySelector<HTMLButtonElement>('[data-note-save]');

            if (editTrigger) {
                editTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (displayEl) displayEl.style.display = 'none';
                    if (formEl) formEl.style.display = '';
                    if (inputEl) {
                        inputEl.focus();
                        inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
                    }
                });
            }

            if (saveBtn) {
                saveBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.onSave(saveBtn, inputEl);
                });
            }
        });
    }

    private onSave(saveBtn: HTMLButtonElement, inputEl: HTMLTextAreaElement | null): void {
        const url = saveBtn.dataset.url;
        if (!url || !inputEl) return;

        const noteValue = inputEl.value;
        const requestUrl = url.replace('NOTE_PLACEHOLDER', encodeURIComponent(noteValue));

        naja.makeRequest('GET', requestUrl, {
            history: false,
        });
    }

    private initSnippetListener() {
        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id === 'snippet--cartFormSnippet') {
                const newContainer = document.querySelector('.base-cart') as HTMLElement;
                if (newContainer) {
                    this.container = newContainer;
                }
                this.init();
            }
        });
    }
}
